const DurationFormat = (days) => {
  const months = Math.floor((days % 365) / 22);
  const day = Math.floor((days % 365) % 22);
  let result;
  if (months !== 0 && day !== 0) {
    result = `${months} ${months < 2 ? 'Month' : 'Months'} ${day} ${
      day < 2 ? 'Day' : 'Days'
    }`;
  } else if (months !== 0 && day === 0) {
    result = `${months} ${months < 2 ? 'Month' : 'Months'}`;
  } else if (months === 0 && day !== 0) {
    result = `${day} ${day < 2 ? 'Day' : 'Days'}`;
  }
  return result;
};
export default DurationFormat;
